// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1beE7","sendOtp":"AuthorizeToLogin_sendOtp__3y7Nt"};